import type { NotificationCategoryDto } from '~/types/api/notice'

export type NoticeCategory = NotificationCategoryDto

/** 列表筛选：空串 = 全部 */
export type NoticeFilter = '' | NoticeCategory

/** 站内页面编码（GET 页面目录 page_code，消息 cta_target 原样使用） */
export type NoticePageCode =
  | 'home'
  | 'rewards'
  | 'wallet'
  | 'affiliate'
  | 'me'
  | 'home_search'
  | 'home_lobby'
  | 'home_favorites'
  | 'rewards_promo'
  | 'rewards_quest'
  | 'rewards_vip'
  | 'rewards_rebate'
  | 'rewards_claims'
  | 'wallet_withdraw'
  | 'wallet_deposit_records'
  | 'wallet_withdraw_records'
  | 'wallet_transfer'
  | 'wallet_payee_accounts'
  | 'affiliate_members'
  | 'affiliate_materials'
  | 'affiliate_bills'
  | 'affiliate_report'
  | 'me_notifications'
  | 'me_security'
  | 'me_kyc'
  | 'me_game_report'

const NOTICE_PAGE_CODES = new Set<string>([
  'home',
  'rewards',
  'wallet',
  'affiliate',
  'me',
  'home_search',
  'home_lobby',
  'home_favorites',
  'rewards_promo',
  'rewards_quest',
  'rewards_vip',
  'rewards_rebate',
  'rewards_claims',
  'wallet_withdraw',
  'wallet_deposit_records',
  'wallet_withdraw_records',
  'wallet_transfer',
  'wallet_payee_accounts',
  'affiliate_members',
  'affiliate_materials',
  'affiliate_bills',
  'affiliate_report',
  'me_notifications',
  'me_security',
  'me_kyc',
  'me_game_report',
])

export function isNoticePageCode(value: string): value is NoticePageCode {
  return NOTICE_PAGE_CODES.has(value)
}

export interface NoticeItem {
  id: string
  cat: NoticeCategory
  icon: string
  title: string
  body: string
  /** 消息时刻（接口 created_at 原值，时刻串）；展示走 <LocalTime> */
  createdAt: string
  unread: boolean
}

/** GET /notifications/{msg_id} 映射后的详情 */
export interface NoticeDetail {
  id: string
  cat: NoticeCategory
  icon: string
  title: string
  body: string
  createdAt: string
  rows: { label: string; value: string }[]
  /** 空字符串不展示 */
  footnote: string
  /** 空字符串不展示按钮 */
  ctaLabel: string
  /** 能跳转时才有，对应 cta_target */
  page?: NoticePageCode
}
